import { Flame } from "lucide-react";
import { useTranslation } from "react-i18next";
import { cn } from "@/lib/utils";
import { useStreak } from "@/features/streak/useStreak";

interface StreakBadgeProps {
  className?: string;
}

export function StreakBadge({ className }: StreakBadgeProps) {
  const { t } = useTranslation();
  const { data } = useStreak();
  const streak = data.current_streak;

  if (streak === 0) return null;

  return (
    <div
      className={cn(
        "inline-flex items-center gap-1.5 rounded-pill border border-hair px-2.5 py-1 text-[12px]",
        className,
      )}
      title={t("streak.longest_label", { count: data.longest_streak })}
    >
      <Flame className="size-3.5 text-orange-500" strokeWidth={1.5} />
      <span className="font-mono font-medium">{streak}</span>
      <span className="text-ink-50">{t("streak.weeks_short")}</span>
    </div>
  );
}
